import useDocumentTitle from 'generic/useDocumentTitle'
import APP from 'environment/APP_CONFIG'

const useAppTitle = (title = '') => {
  useDocumentTitle(title ? `${title} - ${APP.name}` : `${APP.name} - Roseau Technologies`)
}

export default useAppTitle
